import { map } from 'lodash'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Trans } from '@lingui/macro'
import Item from 'Root/App/PopoverPanel/Item'
import Title from 'Root/App/Title'
import { CONTENT_TYPES, OLD_FEATURES_CONTENT_TYPES } from 'lib/element-types'
import { translateWhenIsId } from 'lib/translate-when-is-id'
import { useFeatureEnabledByDate } from 'lib/use-feature-enabled-by-date'

library.add(faChevronRight)

interface MenuCreateContentProps {
  collectionSlug: string
  onClose: Function
  moduleId?: string
}

const MenuCreateContent = ({
  collectionSlug,
  onClose,
  moduleId,
}: MenuCreateContentProps) => {
  const [loading, featureIsEnabledForThisUser] = useFeatureEnabledByDate()

  const createElementPageSearchParams = collectionSlug
    ? `ccid=${collectionSlug}${moduleId ? `&mid=${moduleId}` : ''}`
    : ''

  if (loading) {
    return null
  }

  const currentElements = featureIsEnabledForThisUser
    ? OLD_FEATURES_CONTENT_TYPES
    : CONTENT_TYPES

  return (
    <>
      <div className="my-6">
        <Title size="S">
          <Trans>Crea Contenuto</Trans>
        </Title>
      </div>
      <div className="flex flex-wrap gap-4 sm:gap-12">
        {map(currentElements, (subprops: any, index: string) => (
          <Item
            {...subprops}
            title={translateWhenIsId(subprops.title)}
            description={translateWhenIsId(subprops.description)}
            callback={onClose}
            key={index}
            index={index}
            searchParams={createElementPageSearchParams}
          />
        ))}
      </div>
    </>
  )
}

export default MenuCreateContent
